module.exports = {
      id: "kishoralo-white-usage",
      viewBox: "0 0 625 349",
      url: "/" + "sprite-f96a299a5e63739e5b36582e48c149a3.svg#kishoralo-white",
      toString: function () {
        return this.url;
      }
    }